<template>
  <layout-default-appbar filterabl>
      Ordem Produção DUN
  </layout-default-appbar>
</template>

<script>
import LayoutDefaultAppbar from '@/layouts/default/AppBar.vue';
import { ROUTE_PRODUCAO_DUN } from '@/constants/ROUTES';

export default {
  name: 'ViewLoteDunAppBar',

  components: {
    LayoutDefaultAppbar,
  },

    data() {
    return {
      rota: ROUTE_PRODUCAO_DUN,
    }
  }

};
</script>
